module.exports = __webpack_public_path__ + "static/media/bg-pricing-card.6d9394eb.jpg";